import { Offcanvas } from 'bootstrap';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUsersContext } from '../contexts/users.tsx';
import { Role } from '../models/enums/role.ts';

const Navigation = () => {
    let location = useLocation(); // Access the current location object
    let currentPath = location.pathname;
    const { isLoggedIn, isInRole } = useUsersContext();
    const [userIsAdmin, setUserIsAdmin] = useState(isInRole(Role.admin) || isInRole(Role.superAdmin));
    const [userIsSuperAdmin, setUserIsSuperAdmin] = useState(isInRole(Role.superAdmin));
    const navigate = useNavigate();

    useEffect(() => {
        setUserIsAdmin(isInRole(Role.admin) || isInRole(Role.superAdmin));
        setUserIsSuperAdmin(isInRole(Role.superAdmin));
    }, [isInRole(Role.admin), isInRole(Role.superAdmin)]);

    const handleUserIconClick = (event) => {
        event.preventDefault();
        if (isLoggedIn)
            navigate("/profile");
        else
            navigate("/login");
    }

    const closeOffcanvas = () => {
        const offcanvasElement = document.getElementById('offcanvasNavbar');
        if (offcanvasElement == null) return;

        const bsOffcanvas = Offcanvas.getInstance(offcanvasElement);
        if (bsOffcanvas) {
            bsOffcanvas.hide();
        }

        const backdropElement = document.querySelector('.offcanvas-backdrop');
        if (backdropElement) {
            backdropElement.remove();
        }

        document.body.classList.remove('offcanvas-backdrop', 'modal-open');
        setTimeout(() => {
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = 'auto';
        }, 500);
    };


    return (
        <nav className={`navbar bg-body-tertiary fixed-top`} style={{ zIndex: 999999998 }}>
            <div className="container-fluid maxw-1920">
                <Link className="navbar-brand" to="">AD Nutrition</Link>
                <div className='d-flex gap-2'>
                    <button className="navbar-toggler" type="button" onClick={handleUserIconClick}>
                        <i className="bi bi-person-circle md-2" />
                    </button>
                    <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvasNavbarLabel">AD Nutrition</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>
                    <div className="offcanvas-body">
                        <ul className="navbar-nav justify-content-end flex-grow-1">
                            {
                                !isLoggedIn &&
                                <>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath == '/login' ? "active" : ""}`} to="/login" onClick={() => closeOffcanvas()}>Login</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath == '/register' ? "active" : ""}`} to="/register" onClick={() => closeOffcanvas()}>Register</Link>
                                    </li>
                                </>
                            }
                            {isLoggedIn &&
                                <li className="nav-item">
                                    <Link className={`nav-link ${currentPath == '/journal' ? "active" : ""}`} to="/journal" onClick={() => closeOffcanvas()}>Journal</Link>
                                </li>
                            }
                            <li className="nav-item">
                                <Link className={`nav-link ${currentPath == '/search' ? "active" : ""}`} to="/search" onClick={() => closeOffcanvas()}>Search</Link>
                            </li>
                            {
                                userIsAdmin ? <>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath == '/admin/aliments' ? "active" : ""}`} to="/admin/aliments" onClick={() => closeOffcanvas()}>Aliments</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath == '/admin/categories' ? "active" : ""}`} to="/admin/categories" onClick={() => closeOffcanvas()}>Categories</Link>
                                    </li>
                                    {/* <li className="nav-item">
                                        <Link className={`nav-link ${currentPath == '/admin/meals' ? "active" : ""}`} to="/admin/meals" onClick={() => closeOffcanvas()}>Meals</Link>
                                    </li> */}
                                    {userIsSuperAdmin &&
                                        <li className="nav-item">
                                            <Link className={`nav-link ${currentPath == '/admin/measurement-units' ? "active" : ""}`} to="/admin/measurement-units" onClick={() => closeOffcanvas()}>Measurement Units</Link>
                                        </li>
                                    }
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath == '/admin/recipes' ? "active" : ""}`} to="/admin/recipes" onClick={() => closeOffcanvas()}>Recipes</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath == '/admin/stores' ? "active" : ""}`} to="/admin/stores" onClick={() => closeOffcanvas()}>Stores</Link>
                                    </li>
                                    {/* <li className="nav-item">
                                        <Link className={`nav-link ${currentPath == '/admin/users' ? "active" : ""}`} to="/admin/users" onClick={() => closeOffcanvas()}>Users</Link>
                                    </li> */}
                                    {userIsSuperAdmin &&
                                        <li className="nav-item">
                                            <Link className={`nav-link ${currentPath == '/admin/feedbacks' ? "active" : ""}`} to="/admin/feedbacks" onClick={() => closeOffcanvas()}>Feedbacks</Link>
                                        </li>
                                    }
                                </> : <>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath.startsWith('/aliments') ? "active" : ""}`} to="/aliments" onClick={() => closeOffcanvas()}>Aliments</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath.startsWith('/recipes') ? "active" : ""}`} to="/recipes" onClick={() => closeOffcanvas()}>Recipes</Link>
                                    </li>
                                    {/* <li className="nav-item">
                                        <Link className={`nav-link ${currentPath.startsWith('/meals') ? "active" : ""}`} to="/meals" onClick={() => closeOffcanvas()}>Meals</Link>
                                    </li> */}
                                </>
                            }
                            {
                                isLoggedIn &&
                                <>
                                    <li><hr className="my-1" /></li>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath == '/profile' ? "active" : ""}`} to="/profile" onClick={() => closeOffcanvas()}>Profile</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath.startsWith('/profile/body-measurements') ? "active" : ""}`} to="/profile/body-measurements" onClick={() => closeOffcanvas()}>Body Measurements</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath.startsWith('/profile/journal-names') ? "active" : ""}`} to="/profile/journal-names" onClick={() => closeOffcanvas()}>Journal Names</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath.startsWith('/profile/goals') ? "active" : ""}`} to="/profile/goals" onClick={() => closeOffcanvas()}>Goals</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`nav-link ${currentPath.startsWith('/profile/change-password') ? "active" : ""}`} to="/profile/change-password" onClick={() => closeOffcanvas()}>Change Password</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`nav-link`} to="/logout" onClick={() => closeOffcanvas()}>Logout</Link>
                                    </li>
                                </>
                            }
                            {
                                isLoggedIn &&
                                <li className="nav-item">
                                    <Link className={`nav-link text-warning`} to="/feedbacks/create" onClick={() => closeOffcanvas()}>Feedback</Link>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navigation;